<template>
  <label
    :aria-labelledby="labelId"
    :for="inputId"
    tabindex="0"
    class="relative flex items-start py-3 border-b focus:ring-neutral-700 focus-visible:outline focus-visible:outline-2 focus-visible:outline-neutral-900"
    :class="{
      'sm:items-center sm:min-h-[70px]': isCheckboxCard && !showIconBackground,
      'sm:outline sm:border-0 last:border-b-0 sm:py-3 sm:px-4 sm:rounded-lg': isCheckboxCard,
      'sm:outline-bubblegum-500 sm:outline-2': isChecked && isCheckboxCard,
      'outline-neutral-900 outline-1': !isChecked && isCheckboxCard,
      'cursor-not-allowed opacity-40': disabled,
      'cursor-pointer hover:opacity-70': !disabled,
    }"
    @keydown.space.enter="$el.click()"
  >
    <span class="min-w-0 flex-1">
      <span class="*:text-gray-900 flex justify-between items-center">
        <span class="flex items-center space-x-4 min-w-0 text-base pr-2">
          <span
            v-if="icon.length"
            :class="{ 'rounded-full bg-ocean-100 p-3': showIconBackground }"
          >
            <fa
              :icon="icon"
              class="fa-fw text-lg text-ocean-900"
              :class="{ 'sm:text-2xl': isCheckboxCard && !showIconBackground }"
            />
          </span>
          <span class="flex flex-col flex-1 min-w-0 *:truncate">
            <span :id="labelId">{{ label }}</span>
            <span
              v-if="subLabel"
              class="text-sm text-neutral-500 -mt-1"
            >
              {{ subLabel }}
            </span>
          </span>
        </span>
        <input
          :id="inputId"
          v-model="proxyChecked"
          :aria-checked="isChecked.toString()"
          :role="type"
          tabindex="-1"
          :type="type"
          :value="value"
          :disabled="disabled"
          class="size-5 border-neutral-700 text-neutral-700 flex-shrink-0"
        />
      </span>
    </span>
  </label>
</template>

<script>
export default {
  name: 'VetsterCheckboxInput',

  model: {
    prop: 'modelValue',
    event: 'update:modelValue',
  },

  props: {
    disabled: {
      type: Boolean,
      default: false,
    },
    icon: {
      type: Array,
      default: () => [],
    },
    isCheckboxCard: {
      type: Boolean,
      default: false,
    },
    label: {
      type: String,
      required: true,
    },
    modelValue: {
      type: [Array, Boolean, String],
      default: false,
    },
    showIconBackground: {
      type: Boolean,
      default: false,
    },
    subLabel: {
      type: String,
      default: null,
    },
    type: {
      type: String,
      default: 'checkbox',
    },
    value: {
      type: [String, Boolean],
      default: null,
    },
  },

  computed: {
    inputId() {
      return this.label.replace(/[^a-z0-9]/gi, '-');
    },
    isChecked() {
      return Array.isArray(this.modelValue)
        ? this.modelValue.includes(this.value)
        : this.modelValue === this.value;
    },
    labelId() {
      return `${this.inputId}-label`;
    },
    proxyChecked: {
      get() {
        return this.modelValue;
      },
      set(val) {
        this.$emit('update:modelValue', val);
      },
    },
  },
};
</script>
